import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Feature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Features </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      <b>360-Degree Videos: It’s Already All Around You</b>
                      <br></br>
                      For so long, X-tended Reality (XR) was thought of as impractical and 
                      futuristic—a mind-boggling technology plucked from the pages of 
                      science fiction, solely utilized by diehard gamers and tech geeks. 
                      But the past couple of years have shown us that XR has 
                      already trickled into a variety of industries, from film and entertainment 
                      to education and advertising. This rapidly growing and expanding virtual 
                      environment is powered by 360-degree video, a new kind of medium that allows 
                      viewers to sense the action from all angles and directions, so they feel as if 
                      they’re actually in the scene as it unfolds before their eyes.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>In the Middle of the Action</b>
                      <br></br>
                      Recognizing the potential of this highly immersive means of delivering content, 
                      online platforms such as YouTube, Flickr and Facebook have taken numerous measures 
                      to support 360-degree video formats. In doing so, people are now able to experience 
                      things they wouldn’t likely encounter in “reality,” such as flying a WWII fighter 
                      plane or viewing Earth from the International Space Station, in new and unique ways.
                      <br></br>
                      While these kinds of videos generally provide an immersive experience, 
                      traditional filmmakers and production companies are exploring how 360-degree video 
                      can also transform storytelling and make a viewer feel more emotionally involved. 
                      Some of the most favored videos among those already published have been horror films, 
                      which trap viewers in eerie, highly atmospheric scenes in which they can literally 
                      look over their shoulder to see what’s lurking in the dark.
                      <br></br>
                      Engrossing and emotion-provoking videos like these have given way to an unpredictable 
                      increase in the popularity of virtual reality elements at this year’s major film 
                      festivals—including Cannes, Sundance, Tribeca and Hot Docs—and have accelerated 
                      major film and television studios’ recent VR initiatives.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Storytelling in the Age of Digital Video</b>
                      <br></br>
                      Journalists are also hoping to evoke similar emotions and create empathy in a field 
                      that is often criticized for lacking such components. The New York Times, for example, 
                      recently ventured into the world of 360-degree video storytelling with “The Displaced,” 
                      their Nov. 5 story about the plight of refugee children forced from their homes by war 
                      and persecution. This pioneering journalistic endeavor let viewers move their mobile 
                      devices around to take in the full scenery, exploring the refugee experience in a 
                      highly personal way.
                      <br></br>
                      But storytelling isn’t just for journalism. In fact, the buzzword is also strongly 
                      tied to the advertising industry, and 360-degree video provides a way to create intense 
                      moments and rich, enveloping experiences that can help boost a brand’s story. So much so 
                      that the medium is predicted to be one of the biggest marketing trends to watch for in 2016. 
                      Already several large media organizations, as well as athletes, celebrities and TV show producers, 
                      have put together promotional videos offering a variety of immersive content options to engage fans. 
                      Consumer brands have also begun utilizing 360-degree video technologies in striking advertising 
                      campaigns to reach out to the young, tech-savvy consumers of today.
                      <br></br>
                      In addition to entertainment, news and marketing, there are a whole host of use cases that 
                      360-degree video creators have only just begun to explore. Such use cases include educational 
                      applications, like surgical training tools for medical students, and content that aims to treat 
                      illnesses such as post-traumatic stress disorder in war veterans or phantom limb syndrome in 
                      amputees.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>A New Way to Consume, Create and Connect</b>
                      <br></br>
                      The quality of 360-degree video has improved greatly in recent years, due in large part 
                      to the technology that enables its creation and consumption. What was once only available 
                      for viewing on a personal computer can now also be easily accessed and viewed on a mobile 
                      device. Yet 360-degree video is most impressive when experienced through mobile virtual 
                      reality devices, such as Oculus Go which hit shelves last month.
                      <br></br>
                      Headsets like Oculus Go utilize gyro sensors, geomagnetic sensors and proximity sensors to 
                      shift the 360-degree video and sound in unison with the user’s head movements, 
                      tricking the brain into reacting as if it were all real. And, considering the advantages 
                      of smartphone capabilities, the masses can now experience virtual reality in all its 
                      glory at a comparatively low cost.
                      <br></br>
                      Furthermore, with devices like Samsung Internet for Gear VR app, users can now also browse the web and 
                      experience digital content in a highly immersive environment, as if they were at the cinema 
                      watching it on the big screen. With the ability to stream both 360-degree and 3D videos from the web, 
                      the app provides users with an easily accessible, fully immersive VR viewing experience.
                      <br></br>
                      While the technology utilized to view 360-degree video continues to advance, so does the camera 
                      equipment used to film the content, making it easier and more affordable for just about anyone to 
                      produce their own omnidirectional films. Furthermore, organizations are opening their doors to foster 
                      the creation and development of 360-degree video content. The Sundance Institute, for example, 
                      has established a residency program for independent filmmakers who hope to lay the groundwork for 
                      this new film language. Likewise, YouTube Space is a studio that offers resources for creatives to 
                      produce 360-degree video, and conducts periodic workshops and social gatherings to help creators 
                      collaborate with one another.
                      <br></br>
                      Although 360-degree video has already made its mark on a variety of industries, it is certain that 
                      people will begin to share far more XR content—whether personal experiences or artistic endeavors—as 
                      technology makes it easier for amateurs to produce it themselves. As more content is created, 
                      sites will adapt by adding supportive features, and, soon enough, 360-degree video will allow 
                      people to create, tell and share the stories and experiences that are important to them in a richer 
                      and more immersive way.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Enjoy a glipse of the features available at AbilitàXR:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Feature 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Feature 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Feature;



// WEBPACK FOOTER //
// ./src/views/Pages/Feature/Feature.js